/**
 * Groups an array of objects based on passed property
 * Credit: Ceasar Bautista https://stackoverflow.com/a/34890276/364632
 *
 * Resulting array of objects will have entries in the form of:
 * {
 * 		key: value from the original array for the property passed for grouping ,
 * 		values: entries from the original array that match the grouping criteria
 * }
 *
 * @param {any} array Array to perform grouping on
 * @param {string} property Property to based grouping on
 *
 */

export const groupByArray = (xs, key): { key: any; values: any[] }[] => {
	return xs.reduce(function (rv, x) {
		const v = key instanceof Function ? key(x) : x[key];
		const el = rv.find((r) => r && r.key === v);
		if (el) {
			el.values.push(x);
		} else {
			rv.push({ key: v, values: [x] });
		}
		return rv;
	}, []);
};
